function Footer (){
    return(<>
            <div className="mt-4 text-center">
                {/* <img className="rounded-xl w-50 h-20 m-auto mt-10" src="https://miro.medium.com/max/1000/1*BOrZtZYRwGEe8NlavcSzRA.png" alt="UPI APPS"/>
                <br/>
                <span className="text-xs text-gray-400">Above images only represents a small group of supporting UPI apps,<br/> this website does not affilate with any of them</span>
                <br/> */}
                <span className="text-base mt-4 block text-gray-600">Made with 💖 by <a className="text-rose-600 underline decoration-dotted " href="https://sahiljena.github.io">Sahil Jena</a></span>
                <br/>
            </div>
    </>)
}

export default Footer